import { PageContent } from "@/shared/widgets/layout/PageContent";
import { useNavigate } from "react-router-dom";
import { Button } from "@/shared/ui/button";
import { PlusIcon } from "lucide-react";
import CategoriesList from "./CategoriesList";

const CategoriesIndex = () => {
    const navigate = useNavigate();

    const createButton = (
        <Button onClick={() => navigate("/categories/new")}>
            <PlusIcon className="h-4 w-4 mr-2" />
            Nova Categoria
        </Button>
    );

    return (
        <PageContent
            title="Categorias"
            items={[
                {
                    label: "Início",
                    href: "/",
                },
                {
                    label: "Categorias",
                    href: "/categories",
                },
            ]}
            actions={createButton}
        >
            <div className="rounded-lg overflow-hidden">
                <CategoriesList />
            </div>
        </PageContent>
    );
};

export default CategoriesIndex;